// JsFromRoutes CacheKey b28d07826bfbb5f1b36fbe34c29dc992
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/accounts/new'),
  create: /* #__PURE__ */ definePathHelper('post', '/accounts'),
  checkSlug: /* #__PURE__ */ definePathHelper('get', '/accounts/check-slug'),
  switch: /* #__PURE__ */ definePathHelper('post', '/switch-account/:account_id'),
}
